import styled from "styled-components";

export const Wrapper = styled.div`
    padding-bottom: 180px;
`;

export const Title = styled.h2`
    color: #FFF;
    font-size: 64px;
    font-weight: 800;
    text-align: center;
    margin-bottom: 76px;
`;

export const List = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 64px;
`;
